import { useSortable } from "@dnd-kit/sortable";
import clsx from "clsx";
import { FC, PropsWithChildren } from "react";

import { CanvasRowWidthType } from "../../@types";
import { CloseIcon, DragAndDropIcon } from "../icons";

import styles from "./layout-blocks.module.scss";

type Props = {
  id: string;
  className?: string;
  title: string;
  width: CanvasRowWidthType;
  onRemove: (id: string) => void;
};

const SortableItem: FC<PropsWithChildren<Props>> = ({
  children,
  className,
  id,
  title,
  width,
  onRemove
}) => {
  const { attributes, listeners, setNodeRef, isDragging, isOver } = useSortable(
    {
      id
    }
  );

  const handleRemove = () => {
    onRemove(id);
  };

  return (
    <section
      ref={setNodeRef}
      className={clsx(
        styles.layout_block_wrapper,
        styles[`item_${width}`],
        isDragging && styles.no_border,
        isOver && styles.over,
        className
      )}
      style={{
        cursor: "default"
      }}
      {...attributes}
      {...listeners}
    >
      <div
        id={`draggable-header-${id}`}
        className={clsx(styles.header, isDragging && styles.dragging)}
      >
        <span id={`draggable-header-${id}-title`} className={styles.title}>
          {title}
        </span>
        <div className={styles.icons}>
          <CloseIcon
            data-testid={`canvas-block-${id}-remove-button`}
            onClick={handleRemove}
          />
          <DragAndDropIcon
            id={`draggable-header-button-layout-wrapper-${id}`}
          />
        </div>
      </div>
      <div className={clsx(styles.content, isDragging && styles.dragging)}>
        {children}
      </div>
    </section>
  );
};

export default SortableItem;
